import { useState, useEffect, useCallback, useMemo } from "react";
import ReviewForm from "./Forms/ReviewForm";
import ServiceAdonsForm from "./Forms/ServiceAdonsForm";
import ServiceForm from "./Forms/ServiceForm";
// import ServiceInclusionForm from "./Forms/ServiceInclusionForm";
import { httpService } from "../../services/httpService";
import { toast } from "react-toastify";
import {
  FiFileText,
  FiCheckCircle,
  FiPlusCircle,
  FiCheck,
} from "react-icons/fi";
import { HiArrowSmLeft } from "react-icons/hi";
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import PriceSurchargeForm from "./Forms/PriceSurchargeForm";
import { useProfile } from "../../context/ProfileContext";
import { markSetupStepCompleteById } from "../../utils/vendorSetupSteps";
import { fetchOnlineProfileCached } from "../../hooks/useOnlineProfile";


const ServiceDrawer = ({ isOpen, serviceId, onClose, onSaved }) => {
 
  const [activeTab, setActiveTab] = useState("service");
  const [currentStep, setCurrentStep] = useState(0);
  const [sizeCoatSelection, setSizeCoatSelection] = useState("size_and_coat");
  const [isServiceFormValid, setIsServiceFormValid] = useState(false);
  const [isPricingSurchargeFormValid, setIsPricingSurchargeFormValid] =
    useState(true);
  const [tabProgress, setTabProgress] = useState({
    service: 0,
    // inclusion: 0,
    // adons: 0,
    review: 0,
    pricingSurcharge: 0,
  });

  const [loading, setLoading] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  // const [serviceInclusions, setServiceInclusions] = useState([]);
  const [adonServices, setAdonServices] = useState([]);
  // const [productServices, setProductServices] = useState([]);
  const [currentTab, setCurrentTab] = useState("service");
  // const [serviceCategory, setServiceCategory] = useState("");

  const { profileData, vendorId } = useProfile();
  const isFreePlan = profileData?.accountType === "Free Forever";

  // Callback passed to child to update current tab
  const handleTabChange = (tabId) => {
    setCurrentTab(tabId);
  };
  //api to generate barcode
  const generateRandomBarcode = useCallback(async () => {
    try {
      const response = await httpService.get(
        "vendorservice/generateVendorServiceBarcode",
      );
      return response.data;
    } catch (error) {
      toast.error("Failed to generate service barcode.");
      return null; // Return null on failure
    }
  }, []);
  const [formData, setFormData] = useState({
    service: {
      name: "",
      barcode: null,
      category: {
        service_category_name: "",
        service_category_id: "",
        service_type_id: "",
        service_type_name: "",
        service_category_type_id: "",
      },
      flatDurationHour: 0,
      flatDurationMinutes: 0,
      durationBasedOn: "flat",
      duration: {
        small: {
          hour: 0,
          minutes: 0,
        },
        medium: {
          hour: 0,
          minutes: 0,
        },
        large: {
          hour: 0,
          minutes: 0,
        },
        giant: {
          hour: 0,
          minutes: 0,
        },
      },
      basicPrice: "",
      bookable_online: "yes",
      description: "",
      images: [],
    },
    // inclusion: {},
    // adons: {
    //   servicesIncluded: [],
    //   addons: [],
    //   // products: [],
    //   inclusions: {},
    // },
    pricingSurcharge: {
      priceBasedOnSize: "no",
      priceBasedOnCoat: "no",
      priceDiscountForMulitpleAppointment: "no",
      priceDiscountForClientLabel: "no",
    },
    review: {},
  });

  const resetFormData = () => {
    setFormData({
      service: {
        name: "",
        barcode: null,
        category: {
          service_category_id: "",
          service_type_id: "",
          service_type_name: "",
          service_category_type_id: "",
          type_id: "",
          service_category_name: "",
        },
        taxable: "no",
        taxPercentage: "",
        taxPercentage: "",
        pet_type: [],
        priceUnit: "",
        priceBasedOn: "flat",
        onlineFlatPrice: "",
        offlineFlatPrice: "",
        bookable_online: "yes",
        durationBasedOn: "flat",

        flatDurationHour: 0,
        flatDurationMinutes: 0,

        duration: {
          small: {
            hour: 0,
            minutes: 0,
          },
          medium: {
            hour: 0,
            minutes: 0,
          },
          large: {
            hour: 0,
            minutes: 0,
          },
          giant: {
            hour: 0,
            minutes: 0,
          },
        },
        // onlineSizePrices: { small: 0, medium: 0, large: 0, giant: 0 },
        // offlineSizePrices: { small: 0, medium: 0, large: 0, giant: 0 },
        // onlineSameasOffline: true,
      },
      // inclusion: {},
      // adons: {},
      review: {},
      pricingSurcharge: {
        priceBasedOnSize: "no",
        priceBasedOnCoat: "no",
        priceDiscountForMulitpleAppointment: "no",
        priceDiscountForClientLabel: "no",
      },
      basicPrice: "",
    });
  };

  const resetAllStates = () => {
    resetFormData();
    setHasUnsavedChanges(false);
    setShowConfirmDialog(false);
    setIsSaving(false);
    // setServiceInclusions([]);
    setAdonServices([]);
    setCurrentTab("service");
    resetTabs();
  };

  const handleClose = () => {
    if (hasUnsavedChanges) {
      setShowConfirmDialog(true);
    } else {
      resetAllStates();
      resetTabs();
      onClose();
    }
  };

  const confirmClose = () => {
    setShowConfirmDialog(false);
    resetAllStates();
    resetTabs();
    onClose();
  };
  useEffect(() => {
    if (serviceId && isOpen) {
      // Simulate API call or load logic
      fetchServiceData();
      setTabProgress({
        service: 100,
        // inclusion: 100,
        // adons: 100,
        review: 100,
        pricingSurcharge: 100,
      });
    }
  }, [serviceId, isOpen]);

  // Fetch service inclusions when needed

  // useEffect(() => {
  //   if (isOpen && formData.service.category) {
  //     setServiceCategory(formData.service.category);
  //     // fetchAdonServices();
  //   }
  // }, [isOpen, formData.service.category]);

  // useEffect(() => {
  //   const serviceType =
  //     formData.service.category?.service_type_name?.toLowerCase();
  //   if (serviceType?.includes("boarding")) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       adons: { ...prev.adons, products: [] },
  //     }));
  //   }
  // }, [formData.service.category?.service_type_name]);

  // This useEffect fetches the barcode from the API when creating a new service.
  useEffect(() => {
    if (isOpen && !serviceId) {
      const fetchAndSetBarcode = async () => {
        const newBarcode = await generateRandomBarcode();
        if (newBarcode) {
          setFormData((prev) => ({
            ...prev,
            service: {
              ...prev.service,
              barcode: newBarcode,
            },
          }));
        }
      };
      fetchAndSetBarcode();
    }
  }, [isOpen, serviceId, generateRandomBarcode]);

  // Reset category when drawer closes
  // useEffect(() => {
  //   if (!isOpen) {
  //     setServiceCategory("");
  //   }
  // }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const fetchSizeCoatSelection = async () => {
      try {
        const res = await fetchOnlineProfileCached();
        const saved =
          res?.data?.data?.sizeCoatSelection ??
          res?.data?.sizeCoatSelection ??
          res?.sizeCoatSelection;


        setSizeCoatSelection(
          saved === "only_size" || saved === "only_coat"
            ? saved
            : "size_and_coat",
        );
      } catch (error) {
        console.error("Failed to fetch size/coat selection:", error);
        setSizeCoatSelection("size_and_coat");
      }
    };
    fetchSizeCoatSelection();
  }, [isOpen]);

  function transformedPriceSurcharge(data) {
    const {
      size_surcharges,
      coat_surcharges,
      multiple_appointment_discount,
      client_label_discount,
    } = data;

    return {
      // flags
      priceBasedOnSize: size_surcharges.enabled,
      priceBasedOnCoat: coat_surcharges.enabled,
      priceDiscountForMulitpleAppointment:
        multiple_appointment_discount.enabled,
      priceDiscountForClientLabel: client_label_discount.enabled,

      // maps
      sizeOptions: size_surcharges.options.reduce((map, { size, price }) => {
        map[size] = String(price);
        return map;
      }, {}),

      coatOptions: coat_surcharges.options.reduce((map, { size, price }) => {
        map[size] = String(price);
        return map;
      }, {}),

      multipleAppointmentDiscounts: multiple_appointment_discount.options.map(
        (opt) => ({
          no_of_pet: opt.no_of_pet,
          discount_type: opt.discount_type,
          discount: opt.discount,
        }),
      ),

      clientLabelDiscounts: client_label_discount.options.map((opt) => ({
        label: opt.label,
        discount_type: opt.discount_type,
        discount: opt.discount,
      })),
    };
  }

  const fetchServiceData = async () => {
    setLoading(true);
    try {
      const response = await httpService.get(
        `vendorservice/getvendorservice/${serviceId}`,
      );
      const data = response.data; // Get the actual service data from the response

      const pricingSurchargeData = transformedPriceSurcharge(data);

      // Add tax initialization here
      const taxable = data.tax_percentage > 0 ? "yes" : "no";
      const taxPercentage = data.tax_percentage?.toString() || "";

      // Format service data
      const serviceData = {
        name: data.name,
        barcode: data.barcode,
        // category: data.service_category,
        pet_type: data.pet_type,
        // priceUnit: data.price.price_unit,
        bookable_online: data.bookable_online,
        // priceBasedOn: data.price.price_based_on,
        // onlineFlatPrice: data.price.online.flat,
        // offlineFlatPrice: data.price.offline.flat,
        basicPrice: data.basic_price,
        taxable: data.taxable || (data.tax_percentage > 0 ? "yes" : "no"),
        taxPercentage: data.tax_percentage?.toString() || "",

        flatDurationHour: data.duration.flat.hour,
        flatDurationMinutes: data.duration.flat.minutes,
        durationBasedOn: data.duration.duration_based_on,
        duration: {
          small: {
            hour: data.duration.small.hour,
            minutes: data.duration.small.minutes,
          },
          medium: {
            hour: data.duration.medium.hour,
            minutes: data.duration.medium.minutes,
          },
          large: {
            hour: data.duration.large.hour,
            minutes: data.duration.large.minutes,
          },
          giant: {
            hour: data.duration.giant.hour,
            minutes: data.duration.giant.minutes,
          },
        },
        // onlineSizePrices: {
        //   small: data.price.online.small,
        //   medium: data.price.online.medium,
        //   large: data.price.online.large,
        //   giant: data.price.online.giant,
        // },
        // offlineSizePrices: {
        //   small: data.price.offline.small,
        //   medium: data.price.offline.medium,
        //   large: data.price.offline.large,
        //   giant: data.price.offline.giant,
        // },
        // onlineSameasOffline: data.price.same_as_offline,
        images: data?.images,
        description: data.description || "",
      };
      // Format add-ons data
      const adonsData = {
        addons:
          data.adon_services.map((item) => ({
            _id: item.adon_id,
            name: item.name,
            value: item.value,
          })) || [],
        products:
          data.product_used.map((item) => ({
            _id: item.product_id,
          })) || [],
        inclusions: data?.service_inclusions,
      };

      const formattedData = {
        service: serviceData,
        // inclusion: data.service_inclusions,
        // adons: adonsData,
        pricingSurcharge: pricingSurchargeData,
        review: {},
      };

      setFormData(formattedData);
    } catch (err) {
      console.error("Failed to fetch service data", err);
      toast.error("Could not load service details");
    } finally {
      setLoading(false);
    }
  };

  // const fetchAdonServices = async () => {
  //   try {
  //     if (
  //       formData.service.category &&
  //       formData.service.category.service_category_id &&
  //       formData.service.category.service_category_type_id
  //     ) {
  //       const { data } = await httpService.get(
  //         `/adonservice/getadonservicesbyservicecategory/${formData.service.category.service_category_type_id}`
  //       );
  //       setAdonServices(data);
  //     }
  //   } catch (err) {
  //     console.error("Failed to fetch add-on services", err);
  //     toast.error("Could not load add-on services");
  //   }
  // };

  const handleDataChange = () => {
    setHasUnsavedChanges(true);
  };

  const transformFormDataToPayload = () => {
    const {
      service,
      // inclusion,
      adons,
      pricingSurcharge,
    } = formData;
    const inclusions = adons?.inclusions;
    const showSizeSurcharge = sizeCoatSelection !== "only_coat";
    const showCoatSurcharge = sizeCoatSelection !== "only_size";

    // Add these lines to extract tax info from service data
    const taxable = service.taxable === "yes";
    const tax_percentage = taxable ? Number(service.taxPercentage) : 0;

    // 1. mapping: [ outputKey,        flagProp,                         optionsProp ]
    const surchargeConfig = [
      ["size_surcharges", "priceBasedOnSize", "sizeOptions"],
      ["coat_surcharges", "priceBasedOnCoat", "coatOptions"],
      [
        "multiple_appointment_discount",
        "priceDiscountForMulitpleAppointment",
        "multipleAppointmentDiscounts",
      ],
      [
        "client_label_discount",
        "priceDiscountForClientLabel",
        "clientLabelDiscounts",
      ],
    ];

    // 2. init everything with the correct enabled flag + empty options
    const pricingSurchargeData = surchargeConfig.reduce(
      (acc, [key, flagProp]) => {
        const hiddenSurcharge =
          (key === "size_surcharges" && !showSizeSurcharge) ||
          (key === "coat_surcharges" && !showCoatSurcharge);

        acc[key] = {
          enabled: hiddenSurcharge ? "no" : pricingSurcharge[flagProp],
          options: [],
        };
        return acc;
      },
      {},
    );

    // 3. for **each** config entry, if its flagProp === "yes", copy in the optionsProp
    surchargeConfig.forEach(([key, flagProp, optionsProp]) => {
      if (key === "size_surcharges" && !showSizeSurcharge) return;
      if (key === "coat_surcharges" && !showCoatSurcharge) return;

      if (pricingSurcharge[flagProp] === "yes") {
        let raw = pricingSurcharge[optionsProp] || [];
        // Custom transform only for sizeOptions if it's in object form
        if (key === "size_surcharges" && !Array.isArray(raw)) {
          raw = Object.entries(raw).map(([size, price]) => ({ size, price }));
        }
        // Custom transform only for coatOptions if it's in object form
        if (key === "coat_surcharges" && !Array.isArray(raw)) {
          raw = Object.entries(raw).map(([size, price]) => ({ size, price }));
        }

        pricingSurchargeData[key].options = raw;
      }
    });

    // Transform add-on services
    const adon_services = (adons?.addons || []).map((adonId) => ({
      adon_id: adonId?._id,
      value: adonId?.value, // Default to Free, can be modified based on requirements
      name: adonId?.name,
    }));

    // Transform product used
    // const product_used = (adons?.products || []).map((productId) => ({
    //   product_id: productId?._id,
    // }));

    // Transform images
    const images = service?.images;

    return {
      name: service.name,
      description: service.description,
      barcode: service.barcode,
      service_category: null,
      pet_type: service.pet_type,
      duration: {
        duration_based_on: service.durationBasedOn,
        flat: {
          hour: service.flatDurationHour,
          minutes: service.flatDurationMinutes,
        },
        small: {
          hour: service.duration.small.hour,
          minutes: service.duration.small.minutes,
        },
        medium: {
          hour: service.duration.medium.hour,
          minutes: service.duration.medium.minutes,
        },
        large: {
          hour: service.duration.large.hour,
          minutes: service.duration.large.minutes,
        },
        giant: {
          hour: service.duration.giant.hour,
          minutes: service.duration.giant.minutes,
        },
      },
      bookable_online: service.bookable_online,
      service_inclusions: inclusions,
      adon_services,
      images,
      basic_price: service.basicPrice,
      taxable: service.taxable,
      tax_percentage: tax_percentage,
      service_category: null,
      ...pricingSurchargeData,
    };
  };

  const handleSubmit = async () => {
    const errs = validateService(formData.service);
    if (Object.keys(errs).length) {
      toast.error(
        <div className="flex flex-col" style={{ whiteSpace: "pre-line" }}>
          {Object.values(errs).map((msg, i) => (
            <div key={i}>{msg}</div>
          ))}
        </div>,
      );
      return;
    }
    setIsSaving(true);
    const payload = transformFormDataToPayload();
    // return;

    try {
      if (serviceId) {
        await httpService.put(
          `vendorservice/updatevendorservice/${serviceId}`,
          payload,
        );
        toast.success("Service updated successfully");
      } else {
        await httpService.post("vendorservice/addvendorservice", payload);
        toast.success("Service created successfully");
        if (vendorId) {
          await markSetupStepCompleteById(vendorId, "service");
        }
      }
      resetAllStates();
      resetTabs();
      if (onSaved) {
        onSaved();
      } else {
        onClose();
      }
    } catch (err) {
      console.error("Save failed", err);
      toast.error(err.response?.data?.message || "Failed to save service");
    } finally {
      setIsSaving(false);
    }
  };

  //tabs code
  // Memoize tabs array to prevent unnecessary re-renders
  const tabs = useMemo(() => {
    const allTabs = [
      {
        id: "service",
        label: "Service Details",
        icon: <FiFileText className="w-5 h-5" />,
      },
      // {
      //   id: "inclusion",
      //   label: "Service Inclusions",
      //   icon: <FiCheckCircle className="w-5 h-5" />,
      // },
      {
        id: "pricingSurcharge",
        label: "Pricing Surcharge",
        icon: <FaMoneyBillTrendUp className="w-5 h-5" />,
      },
      // {
      //   id: "adons",
      //   label: "Service Inclusions",
      //   icon: <FiPlusCircle className="w-5 h-5" />,
      // },
      {
        id: "review",
        label: "Review & Submit",
        icon: <FiCheckCircle className="w-5 h-5" />,
      },
    ];

    //for free plan 0 don't need price surcharge 
    if (isFreePlan) {
      return allTabs.filter((tab) => tab.id !== "pricingSurcharge");
    }
    return allTabs;
  }, [isFreePlan]);

  // 1) Parent‐side validator
  const validateService = useCallback((svc) => {
    const errs = {};

    // Name
    if (!svc.name?.trim()) errs.name = "Service Name is required";
    else if (svc.name.length < 3)
      errs.name = "Name must be at least 3 characters";

    // Category
    // if (!svc.category?.service_category_type_id)
    //   errs.category = "Service Category is required";

    // Category
    if (!svc.pet_type || svc.pet_type.length === 0)
      errs.pet_type = "Pet Type is required";

    // Duration
    if (svc.durationBasedOn === "flat") {
      if (+svc.flatDurationHour + +svc.flatDurationMinutes <= 0)
        errs.flatDuration = "Please select a non-zero duration";
    } else {
      ["small", "medium", "large", "giant"].forEach((size) => {
        const d = svc.duration[size];
        if (+d.hour + +d.minutes <= 0)
          errs[`duration_${size}`] =
            `Please set a non-zero duration for ${size}`;
      });
    }
    //pricing
    if (!svc.basicPrice) errs.basicPrice = "Basic Price is required";

    // Pricing
    // if (svc.priceBasedOn === "flat") {
    //   if (+svc.offlineFlatPrice <= 0)
    //     errs.offlineFlatPrice = "Offline price must be greater than 0";
    //   if (
    //     svc.bookable_online === "yes" &&
    //     !svc.onlineSameasOffline &&
    //     +svc.onlineFlatPrice <= 0
    //   ) {
    //     errs.onlineFlatPrice = "Online price must be greater than 0";
    //   }
    // } else {
    //   ["small", "medium", "large", "giant"].forEach((size) => {
    //     if (+svc.offlineSizePrices[size] <= 0)
    //       errs[`offline_${size}`] = `Offline ${size} price must be > 0`;
    //     if (
    //       svc.bookable_online === "yes" &&
    //       !svc.onlineSameasOffline &&
    //       +svc.onlineSizePrices[size] <= 0
    //     ) {
    //       errs[`online_${size}`] = `Online ${size} price must be > 0`;
    //     }
    //   });
    // }

    return errs;
  }, []);

  // Memoize handlers
  const handleNext = useCallback(() => {
    if (currentStep < tabs.length - 1) {
      const errs = validateService(formData.service);
      if (Object.keys(errs).length) {
        // summary toast
        toast.error(
          <div className="flex flex-col" style={{ whiteSpace: "pre-line" }}>
            {Object.values(errs).map((msg, i) => (
              <div key={i}>{msg}</div>
            ))}
          </div>,
        );
        return;
      }

      if (activeTab === "pricingSurcharge" && !isPricingSurchargeFormValid) {
        toast.error(
          "Please complete all discount fields correctly before proceeding",
        );
        return;
      }

      const currentTabId = tabs[currentStep].id;
      setTabProgress((prev) => ({
        ...prev,
        [currentTabId]: 100,
      }));
      const nextStep = currentStep + 1;
      setCurrentStep(nextStep);
      setActiveTab(tabs[nextStep].id);
      handleTabChange(tabs[nextStep].id);
    }
  }, [
    currentStep,
    activeTab,
    formData.service,
    validateService,
    isPricingSurchargeFormValid,
    isServiceFormValid,
    tabs,
    handleTabChange,
  ]);

  const handlePrevious = useCallback(() => {
    if (currentStep > 0) {
      const prevStep = currentStep - 1;
      setCurrentStep(prevStep);
      setActiveTab(tabs[prevStep].id);
      handleTabChange(tabs[prevStep].id);
    }
  }, [currentStep, tabs, handleTabChange]);

  const handleTabClick = useCallback(
    (tabId, index) => {
      // Allow navigation to any tab in edit mode
      if (serviceId) {
        setActiveTab(tabId);
        setCurrentStep(index);
        handleTabChange(tabId);
        return;
      }

      // For new service creation, maintain the original validation logic
      if (
        activeTab === "service" &&
        index > currentStep &&
        !isServiceFormValid
      ) {
        toast.error("Please fill in the required service details");
        return;
      }

      if (
        activeTab === "pricingSurcharge" &&
        !isPricingSurchargeFormValid &&
        index > currentStep
      ) {
        toast.error(
          "Please complete all discount fields correctly before proceeding",
        );
        return;
      }

      const isDisabled =
        index > currentStep && tabProgress[tabs[currentStep].id] !== 100;
      if (!isDisabled) {
        setActiveTab(tabId);
        setCurrentStep(index);
        handleTabChange(tabId);
      }
    },
    [
      activeTab,
      currentStep,
      isServiceFormValid,
      isPricingSurchargeFormValid,
      tabProgress,
      tabs,
      handleTabChange,
      serviceId, // Add serviceId to dependencies
    ],
  );

  const updateProgress = useCallback((tabId, progress) => {
    setTabProgress((prev) => ({
      ...prev,
      [tabId]: progress,
    }));
  }, []);

  // Memoize form data update handlers
  const handleServiceFormUpdate = useCallback(
    (data) => {
      setFormData((prev) => ({ ...prev, service: data }));
      handleDataChange();
      updateProgress("service", 100);
    },
    [setFormData, handleDataChange, updateProgress],
  );

  // const handleInclusionFormUpdate = useCallback(
  //   (data) => {
  //     setFormData((prev) => ({ ...prev, inclusion: data }));
  //     handleDataChange();
  //     updateProgress("inclusion", 100);
  //   },
  //   [setFormData, handleDataChange, updateProgress]
  // );

  const handleAdonsFormUpdate = useCallback(
    (data) => {
      setFormData((prev) => ({ ...prev, adons: data }));
      handleDataChange();
      updateProgress("adons", 100);
    },
    [setFormData, handleDataChange, updateProgress],
  );

  const handlePricingSurchargeFormUpdate = useCallback(
    (data) => {
      setFormData((prev) => ({ ...prev, pricingSurcharge: data }));
      handleDataChange();
      updateProgress("pricingSurcharge", 100);
    },
    [setFormData, handleDataChange, updateProgress],
  );

  const handleReviewFormUpdate = useCallback(() => {
    handleDataChange();
    updateProgress("review", 100);
    // Close the drawer after successful submission
    resetTabs();
  }, [handleDataChange, updateProgress]);

  const resetTabs = () => {
    setCurrentStep(0);
    setActiveTab("service");
    setIsServiceFormValid(false);
    setIsPricingSurchargeFormValid(true);
    setTabProgress({
      service: 0,
      // inclusion: 0,
      adons: 0,
      review: 0,
      pricingSurcharge: 0,
    });
  };
  // Memoize tab content
  const tabContent = useMemo(() => {
    switch (activeTab) {
      case "service":
        return (
          <ServiceForm
            isActive={activeTab === "service"}
            // setServiceCategory={setServiceCategory}
            data={formData.service}
            updateData={handleServiceFormUpdate}
            onValidationChange={setIsServiceFormValid}
            serviceId={serviceId}
          />
        );
      // case "inclusion":
      //   return (
      //     <ServiceInclusionForm
      //       isActive={activeTab === "inclusion"}
      //       serviceCategory={serviceCategory}
      //       data={formData.inclusion}
      //       updateData={handleInclusionFormUpdate}
      //     />
      //   );
      case "pricingSurcharge":
        return (
          <PriceSurchargeForm
            isActive={activeTab === "pricingSurcharge"}
            data={formData.pricingSurcharge}
            updateData={handlePricingSurchargeFormUpdate}
            onValidationChange={setIsPricingSurchargeFormValid}
            selectedPetTypes={formData.service.pet_type}
            sizeCoatSelection={sizeCoatSelection}
          />
        );
      // case "adons":
      //   return (
      //     <ServiceAdonsForm
      //       isActive={activeTab === "adons"}
      //       // serviceCategory={formData.service.category}
      //       data={formData.adons}
      //       updateData={handleAdonsFormUpdate}
      //       petType={formData.service.petType} // <-- Pass as a separate prop
      //     />
      //   );
      case "review":
        return (
          <ReviewForm
            isActive={activeTab === "review"}
            data={formData}
            onDataChange={handleReviewFormUpdate}
            adonServices={adonServices}
            // productServices={productServices}
          />
        );
      default:
        return null;
    }
  }, [
    activeTab,
    serviceId,
    // serviceCategory,
    formData,
    handleServiceFormUpdate,
    // handleInclusionFormUpdate,
    handleAdonsFormUpdate,
    handleReviewFormUpdate,
    adonServices,
    handlePricingSurchargeFormUpdate,
    setIsPricingSurchargeFormValid,
    sizeCoatSelection,
    // productServices,
  ]);

  return (
    <>
      {/* Confirmation Dialog */}
      {showConfirmDialog && (
        <div className="fixed inset-0 z-[10002] bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <h3 className="text-xl font-semibold mb-4">Unsaved Changes</h3>
            <p className="mb-6">
              You have unsaved changes. Are you sure you want to close?
            </p>
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setShowConfirmDialog(false)}
                className="px-4 py-2 hover:text-gray-800 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={confirmClose}
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
              >
                Close anyway
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Main Drawer */}
      <div
        className={`fixed inset-0 z-[10001] transition-all duration-300 ease-in-out ${
          isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      >
        <div
          className="absolute inset-0 bg-black bg-opacity-40 backdrop-blur-[2px]"
          onClick={handleClose}
        />
        <div
          className={`absolute right-0 top-0 h-full w-full lg:w-3/4 2xl:w-1/2 bg-white shadow-xl transform transition-transform duration-300 ease-out ${
            isOpen ? "translate-x-0" : "translate-x-full"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Loading Skeleton */}
          {loading && (
            <div className="absolute inset-0 bg-white bg-opacity-90 z-10">
              <div className="p-4 space-y-4 animate-pulse">
                <div className="h-8 bg-gray-200 rounded w-1/3"></div>
                <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                <div className="h-4 bg-gray-200 rounded w-1/3"></div>
                <div className="mt-8 space-y-6">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="space-y-3">
                      <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                      <div className="h-10 bg-gray-200 rounded"></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Header */}
          <div className="flex justify-start items-center p-2 border-b bg-white shadow-sm gap-2">
            <button
              onClick={handleClose}
              className="flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
            >
              <HiArrowSmLeft className="w-8 h-8" />
            </button>
            <h2 className="text-2xl font-bold font-medium">
              {!serviceId ? "Add" : "Edit"} Grooming Service
            </h2>
          </div>

          {/* Content */}
          {isOpen && (
            <>
              <div className="flex h-[calc(100vh-110px)]">
                <div className="w-1/4 p-4 border-r border-gray-200 bg-gray-50">
                  <div className="flex flex-col space-y-3">
                    {tabs.map((tab, index) => {
                      const isActive = tab.id === activeTab;
                      const isCompleted = tabProgress[tab.id] === 100;
                      const isDisabled = index > currentStep && !isCompleted;
                      const isClickDisabled =
                        // For edit mode, allow clicking on any tab
                        serviceId
                          ? false
                          : // For new service creation, maintain original logic
                            isDisabled ||
                            (tab.id !== "service" &&
                              currentStep === 0 &&
                              !isServiceFormValid);

                      return (
                        <div
                          key={tab.id}
                          className={`group relative ${
                            isClickDisabled
                              ? "opacity-50 cursor-not-allowed"
                              : "cursor-pointer"
                          }`}
                          onClick={() =>
                            !isClickDisabled && handleTabClick(tab.id, index)
                          }
                        >
                          <div
                            className={`flex items-center p-3 rounded-lg transition-all duration-200 ${
                              isActive
                                ? "bg-blue-50 border-blue-500 shadow-sm"
                                : "hover:bg-gray-100"
                            }`}
                          >
                            <div
                              className={`w-10 h-10 flex items-center justify-center rounded-full mr-3 ${
                                isActive
                                  ? "bg-blue-500 text-white"
                                  : isCompleted
                                    ? "bg-green-500 text-white"
                                    : "bg-gray-200 text-gray-600"
                              }`}
                            >
                              {isCompleted ? (
                                <FiCheck className="w-6 h-6" />
                              ) : (
                                tab.icon
                              )}
                            </div>
                            <div className="flex-1">
                              <h3
                                className={`font-medium ${
                                  isActive ? "text-blue-900" : "text-gray-900"
                                }`}
                              >
                                {tab.label}
                              </h3>
                              <div className="mt-1 h-1 bg-gray-200 rounded-full overflow-hidden">
                                <div
                                  className={`h-full transition-all duration-500 ${
                                    isCompleted
                                      ? "bg-green-500"
                                      : isActive
                                        ? "bg-blue-500"
                                        : "bg-gray-300"
                                  }`}
                                  style={{ width: `${tabProgress[tab.id]}%` }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="w-3/4 p-4 space-y-4 overflow-auto bg-white">
                  <div className="transition-opacity duration-200">
                    {tabContent}
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Footer */}
          <div className="absolute w-full bottom-0 p-2 bg-white border-t shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]">
            <div className="flex flex-wrap items-center justify-end gap-4">
              {currentTab !== "service" && (
                <button
                  type="button"
                  onClick={handlePrevious}
                  className="min-w-[120px] px-4 py-2.5 border border-yellow-600 text-yellow-600 rounded-md hover:bg-yellow-50 transition-colors focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
                >
                  Previous
                </button>
              )}

              {currentTab !== "review" && (
                <button
                  type="button"
                  onClick={handleNext}
                  className="min-w-[120px] px-4 py-2.5 bg-primary text-white rounded-md hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                  Next
                </button>
              )}

              {/* {currentTab === "review" && ( */}
              <button
                type="button"
                onClick={handleSubmit}
                disabled={isSaving}
                className="min-w-[120px] px-4 py-2.5 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:opacity-50"
              >
                {isSaving ? (
                  <>
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white inline-block"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Saving...
                  </>
                ) : (
                  `${serviceId ? "Update" : "Save"} Service`
                )}
              </button>
              {/* )} */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceDrawer;
